import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

const initialState = {
    componentsTree: {
        selectedNodeKey: null,
    },
}

const catalogItemSlice = createSlice({
    name: 'catalogItem',
    initialState,
    reducers: {
        setSelectedNodeKey: (state, action) => {
            state.componentsTree.selectedNodeKey = action.payload
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const catalogItemActions = catalogItemSlice.actions

export default catalogItemSlice.reducer
